import React, {
  useState,
  useEffect
} from "react";
import {
  Row,
  Modal,
  Form
} from "react-bootstrap";
import { FormContext } from "reusable-components/InputFields/FormContext";
import Element from "reusable-components/InputFields/input";
import "./UploadDocuments.css";
import { v4 } from "uuid";
import { makeCygnusApiCall } from "api/api";


const UploadDocuments = (props) => {
  const [elements, setElements] = useState([{
    "id": v4(),
    "label": "",
    "mandatory": false,
    "approval": false,
    "disabled": false,
    "placeholder": "",
    "type": "file",
    "example": null,
    "pivot": true,
    "pivotreverse": false,
    "value": "",
    "width": 12,
    "filelimit": "multiple"
  }]);
  const [uploadStatus, setUploadStatus] = useState(null);

  const uploadDocuments = async (files) => {
    props.setfileuploading(true)
    if (props.filetype === 'excel') {
      const payloadFormat = new FormData();
      payloadFormat.append("FlowOrchestratorId", Number(props.floworchestratoridexcelimport))
      payloadFormat.append("File", files[0]);
      setUploadStatus(`Uploading ${1} of ${files.length}`)

      const response = await makeCygnusApiCall({
        type: "POST",
        payload: payloadFormat,
        payload_is_file: true,
        url: "/on_demand/",
        show_message: true,
        customized_success_message: "Successfully uploaded your file/s",
        customized_failure_message: "Unable to fetch your file/s., please try again. If the problem persists, please contact support and attach a screenshot.",
        customized_error_message: "Error occured while fetching your file/s., please contact support and attach a screenshot.",
        isblob: false,
        default_message: true,
      })

    }
    else {
      for (let i = 0; i < files.length; i++) {
        const payloadFormat = new FormData();
        payloadFormat.append("ClientMasterId", props.clientmasterid);
        payloadFormat.append("files", files[i]);
        setUploadStatus(`Uploading ${i + 1} of ${files.length}`)

        const response = await makeCygnusApiCall({
          type: "POST",
          payload: payloadFormat,
          payload_is_file: true,
          url: "/upload/",
          show_message: false,
          customized_success_message: "Successfully uploaded your file/s.",
          customized_failure_message: "Unable to fetch your file/s., please try again. If the problem persists, please contact support and attach a screenshot.",
          customized_error_message: "Error occured while fetching your file/s., please contact support and attach a screenshot.",
          isblob: false,
          path: "/tax",
          istax: true
        })

        if (!response.success) {
          break;
        }

      }
    }


    setUploadStatus(null)
    // setting the elements as intial object to avoid unncessary api call after reloading
    setElements([{
      "id": v4(),
      "label": "",
      "mandatory": false,
      "approval": false,
      "disabled": false,
      "placeholder": "",
      "type": "file",
      "example": null,
      "pivot": true,
      "pivotreverse": false,
      "value": "",
      "width": 12,
      "filelimit": "multiple"
    }])
    props.refresh()
    props.onHide()
    props.setfileuploading(false)
  }

  useEffect(() => {
    console.log(props.filetype)
    if (elements[0]["value"] !== "") {
      uploadDocuments(elements[0]["value"])
    }
  }, [elements])


  const handleChange = (field_id, event) => {
    const newElements = [...elements]
    newElements.forEach(field => {
      const { type, id } = field;
      if (field_id === id) {
        switch (type) {
          case 'file':
            field['value'] = event;
            break;

          default:
            field['value'] = event.target.value;
            break;
        }
      }
      const newFullSchema = [...newElements]
      setElements(newFullSchema)
    });
    // console.log(newElements)
  }

  const handleClose = () => {
    props.setfileuploading(false)
    props.onHide()
  }

  return (
    <>
      <div
        className="modaloverlay"
      />
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        centered
        className={"smallmodal"}
        contentClassName={"uploadDocumentsModal"}
      >
        <Modal.Header className={"uploadDocumentFullHeader"}>
          <h5 className={"uploadDocumentheader"}>&nbsp;{props.filetype === 'excel' ? 'Upload Excel' : 'Upload Document'}</h5>
          <button
            type="button"
            className={"closeButton"}
            onClick={handleClose}
            aria-label="Close"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </Modal.Header>
        <Modal.Body style={{ padding: 0, margin: 0 }}>
          {props.fileUploading && (
            <div className="overlay-style">
              <div className="text-style">
                {uploadStatus || "Uploading"}
              </div>
            </div>
          )}
          <FormContext.Provider value={{ handleChange }}>
            <Form>
              <Row className="no-gutter">
                {
                  elements &&
                  elements.map((field, i) =>
                    <Element
                      key={i}
                      field={field}
                      md={12}
                    />)
                }
              </Row>
            </Form>
          </FormContext.Provider>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default UploadDocuments;